module.exports = __webpack_public_path__ + "img/ludo-competition_ar.f14b33c5.png";